import React, { FC } from "react";

export const VerifiedBadge: FC<JSX.IntrinsicAttributes> = (props) => {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 25C0 11.1929 11.1929 0 25 0V0C38.8071 0 50 11.1929 50 25V25C50 38.8071 38.8071 50 25 50V50C11.1929 50 0 38.8071 0 25V25Z"
        fill="#E8F6F1"
      />
      <path
        d="M25.8125 9.1875L37.5625 14.1875C38.9375 14.8125 40 16.125 40 17.75C39.9375 24 37.375 35.3125 26.625 40.5C25.5625 41 24.375 41 23.3125 40.5C12.5625 35.3125 10 24 10 17.75C9.9375 16.125 11 14.8125 12.375 14.1875L24.125 9.1875C24.375 9.0625 24.6875 9 25 9C25.25 9 25.5625 9.0625 25.8125 9.1875ZM32.0625 22.0625H32C32.625 21.5 32.625 20.5625 32 19.9375C31.4375 19.375 30.5 19.375 29.9375 19.9375L23 26.9375L20.0625 24C19.4375 23.375 18.5 23.375 17.9375 24C17.3125 24.5625 17.3125 25.5 17.9375 26.0625L21.9375 30.0625C22.5 30.6875 23.4375 30.6875 24.0625 30.0625L32.0625 22.0625Z"
        fill="#13815E"
      />
    </svg>
  );
};
